import { SVGPropsIcon } from 'src/types';

export const NavbarCherry = (props: SVGPropsIcon) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none">
    <g clipPath="url(#clip0_15121_15310)">
      <path
        d="M4.48438 4.89453C5.15557 4.89453 5.74677 4.71131 6.23498 4.47751C5.73933 5.41009 5.44236 6.48961 5.38342 7.60289C3.40165 7.81564 1.84766 9.47823 1.84766 11.5156C1.84766 13.6965 3.62183 15.5 5.80273 15.5C6.47462 15.5 7.11823 15.3107 7.69547 14.9941C6.79997 14.1162 6.24219 12.8658 6.24219 11.5156C6.24219 10.1655 6.79997 8.94437 7.69547 8.06649C7.25098 7.82262 6.76667 7.65679 6.26096 7.59236C6.45207 4.48621 8.79788 1.9241 11.8224 1.45661C11.0521 2.53808 10.6367 3.82851 10.6367 5.18338V7.60495C8.66456 7.82685 7.12109 9.4851 7.12109 11.5156C7.12109 13.6965 8.89527 15.5 11.0762 15.5C13.2571 15.5 15.0312 13.6965 15.0312 11.5156C15.0312 9.4851 13.4878 7.82685 11.5156 7.60495V5.18338C11.5156 3.69759 12.0941 2.30073 13.1447 1.25016L13.8949 0.5H12.834C10.7699 0.5 8.89928 1.34171 7.54578 2.69944C7.19044 2.35829 6.05107 1.37891 4.48438 1.37891C2.63043 1.37891 1.36185 2.76032 1.30051 2.81915L0.96875 3.13672L1.30051 3.45429C1.36185 3.51311 2.63043 4.89453 4.48438 4.89453ZM11.0762 10.1973C10.3492 10.1973 9.75781 10.7887 9.75781 11.5156H8.87891C8.87891 10.3042 9.8647 9.31836 11.0762 9.31836V10.1973ZM5.80273 10.1973C5.07581 10.1973 4.48438 10.7887 4.48438 11.5156H3.60547C3.60547 10.3042 4.59126 9.31836 5.80273 9.31836V10.1973Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_15121_15310">
        <rect width="15" height="15" fill="white" transform="translate(0.5 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
